import { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { MarkerIcon } from '@client/images/icons/MarkerIcon';
import type { MarkerProps } from './interfaces';
import type { SvgIconProps } from '@mui/material';

const useStyles = makeStyles({ name: 'Pin' })((theme) => ({
  root: {
    fontSize: '18px',
    overflow: 'visible',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    top: 'calc(50% - 12px)',
    left: '50%',
    zIndex: 1,
    transition: 'none',
    cursor: 'pointer',

    '&:hover': {
      color: theme.palette.grey[600],
      fill: theme.palette.grey[50],
    },
  },
  active: {
    color: theme.palette.grey[600],
    fill: theme.palette.grey[50],
  },
}));

interface PinProps {
  readonly isActive?: boolean;
  readonly onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const Pin = memo<MarkerProps & SvgIconProps & PinProps>(({ isActive, zIndex, ...restProps }) => {
  const { classes, cx } = useStyles();

  return (
    <MarkerIcon
      role="button"
      className={cx(classes.root, isActive && classes.active)}
      {...restProps}
    />
  );
});

export default Pin;
